module.exports = "<div class=\"pretty p-smooth p-default p-round\">\r\n  <input\r\n    type=\"radio\"\r\n    name=\"repeat\"\r\n    (change)=\"check()\"\r\n    [checked]=\"checked\"\r\n  >\r\n  <div class=\"state p-success-o\">\r\n    <label>{{ title }}</label>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/RadioComponent/radio.component.html
// module id = ./src/app/common/components/RadioComponent/radio.component.html
// module chunks = main